import { apiClient } from './client';

export function enableFedExQrCodes (shopId: number | string, integrationSlug: string) {
  return apiClient.post(`/${shopId}/shop/integrations/${integrationSlug}/enable-fedex-qr-codes`);
}

export interface EnableNegotiatedCarriersResponse {
  enabled: number;
  failed: number;
  errors: { carrier: string; message: string }[];
  skipped: number;
  skippedCarriers: { carrier: string; reason: string }[];
}

export function enableNegotiatedCarriers (shopId: number | string) {
  return apiClient.post<EnableNegotiatedCarriersResponse>(`/${shopId}/shipping/carriers/enable-negotiated`);
}
